<template>
    <v-tabs v-if="$bp.lgAndUp || permanent" v-model="selectedTab" color="primary" dark id="tabs" height="56px" slider-color="white" grow>
        <v-tab
            v-for="(tab, i) in allowed_tabs"
            :key="tab.name"
            :class="['tab-button pa-0 caption', { active: selectedComponent === tab.name }]"
            @click="selectedTab != i ? setTab(tab.name, i) : ''"
            class="primary"
        >
            <v-icon v-if="tab.icon" class="mr-2">{{ tab.icon }}</v-icon>
            {{ tab.title != undefined ? $t(`lang.${tab.title}`) : tab.text }}
        </v-tab>
        <v-tabs-items>
            <v-tab-item v-for="tab in allowed_tabs" :key="tab.name"> </v-tab-item>
        </v-tabs-items>
    </v-tabs>
    <v-toolbar v-else-if="allowed_tabs.length > 0" flat color="primary" id="tabs">
        <v-menu content-class="no-stripe" v-if="allowed_tabs.length > 1">
            <v-toolbar-side-icon slot="activator" class="ml-3 white--text"></v-toolbar-side-icon>
            <v-list>
                <v-list-tile
                    v-for="(tab, i) in allowed_tabs"
                    :key="tab.name"
                    :class="['menu-tab-button', { active: selectedComponent === tab.name }]"
                    @click="selectedTab != i ? setTab(tab.name, i) : ''"
                >
                    <v-list-tile-content>
                        <v-list-tile-title class="no-hover">{{ $t(`lang.${tab.title}`) }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-menu>
        <span class="white--text fs-22" :style="allowed_tabs.length <= 1 ? 'padding-left: 30px;' : ''">{{ selectedComponent | start_case }}</span>
    </v-toolbar>
</template>

<script>
export default {
    props: ["tabs", "selectedComponent", "permanent", "updateParams"],
    data() {
        return {
            selectedTab: 0,
        };
    },
    computed: {
        allowed_tabs() {
            return this.tabs && this.tabs.length > 0
                ? this.tabs.filter((option) => !option.perms || (option.perms && option.perms.every((perm) => this.hasPerm(perm))))
                : [];
        },
    },
    watch: {
        selectedComponent: function(newVal, oldVal) {
            if (this.allowed_tabs) {
                let index = this.allowed_tabs.map((t) => t.name).indexOf(this.selectedComponent);
                this.selectedTab = index > 0 ? index : 0;
                //console.log(this.selectedTab);
            }
        },
    },
    methods: {
        setTab(tab_name, index) {
            this.$emit("button", tab_name);
            if (!!this.updateParams)
                this.$router.push({
                    name: this.$route.name,
                    params: { id: this.$route.params.id ? this.$route.params.id : "", tab: index > 0 ? tab_name : null, loader: false },
                });
        },
    },
};
</script>
